import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'lib-mailing-address',
  templateUrl: './mailing-address.component.html',
  styleUrls: ['./mailing-address.component.css']
})
export class MailingAddressComponent implements OnInit {

  @Input() mailAddressForm: any;
  @Input() unitTypeList = []
  @Input() streetTypeList = []
  @Input() stateList = []
  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.mailAddressForm.addControl("ma_str_nbr", this.fb.control("", [Validators.pattern(/^[0-9]*$/)]))
    this.mailAddressForm.addControl("ma_str_nbr_frac", this.fb.control(""))
    this.mailAddressForm.addControl("ma_str_dir_prefix", this.fb.control(""))
    this.mailAddressForm.addControl("ma_str_nm", this.fb.control(""))
    this.mailAddressForm.addControl("ma_str_dir_suffix", this.fb.control(""))
    this.mailAddressForm.addControl("ma_str_type", this.fb.control(""))
    this.mailAddressForm.addControl("ma_unit_type", this.fb.control(""))
    this.mailAddressForm.addControl("ma_unit_nbr", this.fb.control(""))
    this.mailAddressForm.addControl("ma_city", this.fb.control("", this.requiredValidator))
    this.mailAddressForm.addControl("ma_state", this.fb.control("", this.requiredValidator))
    this.mailAddressForm.addControl("ma_zipcd", this.fb.control("", [this.requiredValidator, Validators.pattern(/^[0-9]*$/), Validators.minLength(5)]))
    this.mailAddressForm.addControl("ma_careof", this.fb.control(""))
    this.mailAddressForm.addControl("ma_commercial", this.fb.control("", this.requiredValidator))
  }

  requiredValidator(control: AbstractControl): { [key: string]: any } | null {
    const data = control.value ?? ""
    if (data.trim().length !== 0) {
      return null;
    }
    return { required: true };
  }

  ngAfterViewInit(): void {

    window.addEventListener('keydown', (e : any) => {
      if (e.target.type == "radio") {   // if you need to filter <input> elements
          switch (e.key) {
              case "ArrowUp": // up
              case "ArrowRight": // right
                  e.preventDefault();
                  break;
              case "ArrowDown": // down
              case "ArrowLeft": // left
                  e.preventDefault();
                  break;
              default:
                  break;
          }
      }
  }, {
      capture: true,   // this disables arrow key scrolling in modern Chrome
      passive: false   // this is optional, my code works without it
  });
  }

}
